import {
  AuthResponseSchema,
  type ConfirmPasswordResetInput,
  type LoginInput,
  MeResponseSchema,
  type RequestPasswordResetInput,
  SessionsListResponseSchema,
  type SignupInput,
  type VerifyEmailInput,
} from '@disparos/contracts';
import { z } from 'zod';
import { apiFetch } from './client';

const VoidSchema = z.void();

export async function signup(input: SignupInput) {
  return apiFetch('/auth/signup', AuthResponseSchema, {
    method: 'POST',
    body: input,
  });
}

export async function login(input: LoginInput) {
  return apiFetch('/auth/login', AuthResponseSchema, {
    method: 'POST',
    body: input,
  });
}

export async function logout() {
  return apiFetch('/auth/logout', VoidSchema, { method: 'POST' });
}

export async function getMe(signal?: AbortSignal) {
  return apiFetch('/auth/me', MeResponseSchema, { signal });
}

export async function listSessions(signal?: AbortSignal) {
  return apiFetch('/auth/sessions', SessionsListResponseSchema, { signal });
}

export async function revokeSession(id: string) {
  return apiFetch(`/auth/sessions/${id}/revoke`, VoidSchema, { method: 'POST' });
}

export async function switchTenant(tenantId: string) {
  return apiFetch('/auth/switch-tenant', AuthResponseSchema, {
    method: 'POST',
    body: { tenantId },
  });
}

export async function requestPasswordReset(input: RequestPasswordResetInput) {
  return apiFetch('/auth/password-reset/request', VoidSchema, {
    method: 'POST',
    body: input,
  });
}

export async function confirmPasswordReset(input: ConfirmPasswordResetInput) {
  return apiFetch('/auth/password-reset/confirm', VoidSchema, {
    method: 'POST',
    body: input,
  });
}

export async function verifyEmail(input: VerifyEmailInput) {
  return apiFetch('/auth/verify-email', VoidSchema, {
    method: 'POST',
    body: input,
  });
}

export async function resendVerificationEmail() {
  return apiFetch('/auth/resend-verification', VoidSchema, {
    method: 'POST',
  });
}
